var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9307 7C16.9307 4.37665 19.0573 2.25 21.6807 2.25C24.304 2.25 26.4307 4.37665 26.4307 7C26.4307 8.45398 25.7774 9.75538 24.7483 10.6267V16.214L21.6806 14.6789L18.6129 16.214V10.6266C17.5839 9.75531 16.9307 8.45394 16.9307 7ZM21.6807 3.75C19.8857 3.75 18.4307 5.20507 18.4307 7C18.4307 8.79493 19.8857 10.25 21.6807 10.25C23.4756 10.25 24.9307 8.79493 24.9307 7C24.9307 5.20507 23.4756 3.75 21.6807 3.75ZM20.1129 11.4852V13.786L21.6806 13.0016L23.2483 13.786V11.4852C22.7575 11.6568 22.23 11.75 21.6807 11.75C21.1313 11.75 20.6037 11.6567 20.1129 11.4852Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.25H15V7.75H6.75V28.25H23.25V18H24.75V29.75H5.25V6.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.75H9L9 10.25H13V11.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.25V19.75L21 19.75V18.25L9 18.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75V21.25L21 21.25V22.75L9 22.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25.75L13 25.75L13 24.25L9.00001 24.25L9 25.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.3f87b0a143aacfb26c42e6a8ba68a4b9.svg";
export { ForwardRef as ReactComponent };